import ownerDocument from './ownerDocument';
export default function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc && doc.defaultView || window;
}


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/esm/ownerWindow.js
// module id = 990
// module chunks = 0